export const tinCan4Inch = 30706;
export const tinCan5Inch = 30708;
export const tinCan7Inch = 30710;
export const flatBottomBag = 30712;
export const gussetBag = 30714;
export const standUpPouch = 30927;
export const standUpPouchWithValve = 30926;
